/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAuthSignerEmail_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null };

export type GetAuthSignerEmail_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly authorizedSigner: GetAuthSignerEmail_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson | null };

export type GetAuthSignerEmail_Query = { readonly __typename: 'Query', readonly creditApplication: GetAuthSignerEmail_creditApplication_CreditApplication | null };


export type GetAuthSignerEmailVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetAuthSignerEmail = GetAuthSignerEmail_Query;


export const GetAuthSignerEmailDocument = gql`
    query GetAuthSignerEmail($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    authorizedSigner {
      id
      email
    }
  }
}
    `;

/**
 * __useGetAuthSignerEmail__
 *
 * To run a query within a React component, call `useGetAuthSignerEmail` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthSignerEmail` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthSignerEmail({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetAuthSignerEmail(baseOptions: Apollo.QueryHookOptions<GetAuthSignerEmail, GetAuthSignerEmailVariables> & ({ variables: GetAuthSignerEmailVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthSignerEmail, GetAuthSignerEmailVariables>(GetAuthSignerEmailDocument, options);
      }
export function useGetAuthSignerEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthSignerEmail, GetAuthSignerEmailVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthSignerEmail, GetAuthSignerEmailVariables>(GetAuthSignerEmailDocument, options);
        }
export function useGetAuthSignerEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthSignerEmail, GetAuthSignerEmailVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthSignerEmail, GetAuthSignerEmailVariables>(GetAuthSignerEmailDocument, options);
        }
export type GetAuthSignerEmailHookResult = ReturnType<typeof useGetAuthSignerEmail>;
export type GetAuthSignerEmailLazyQueryHookResult = ReturnType<typeof useGetAuthSignerEmailLazyQuery>;
export type GetAuthSignerEmailSuspenseQueryHookResult = ReturnType<typeof useGetAuthSignerEmailSuspenseQuery>;
export type GetAuthSignerEmailQueryResult = Apollo.QueryResult<GetAuthSignerEmail, GetAuthSignerEmailVariables>;